import { ElLoading } from 'element-plus'

let loadingInstance = null

const showLoading = (text) => {
    hideLoading();
    loadingInstance = ElLoading.service({
        lock: true, // 锁定屏幕滚动
        text: text,
        background: 'rgba(122, 122, 122, 0.8)', // 半透明背景
        fullscreen: true // 全屏加载（如需局部加载，传target参数）
    })
}

const hideLoading = () => {
    if (loadingInstance) {
        loadingInstance.close()
        loadingInstance = null
    }
}

export {
    showLoading,
    hideLoading
}